import React from "react";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import "./style.scss";
import { useTranslation } from "react-i18next";

const CardDescription: React.FC = () => {
  const userData = useSelector((state: State) => state.auth.userData.promotion);
  const { t } = useTranslation();
  return (
    <>{userData && <>{userData.displayName ? <span>{userData.displayName}</span> : <span>{t("brak")}</span>}</>}</>
  );
};

export default CardDescription;
